__turbopack_context__.v({
  "className": "YxDAoq_className",
  "variable": "YxDAoq_variable",
});
